/**
 * Připravenost obchodu se po zápisu obnoví sama (KAN-2011).
 *
 * Readiness čte skoro celé nastavení obchodu (profil firmy, IBAN, stroje,
 * doprava, ceník …), ale jen část mutací ji po sobě invalidovala — na test21
 * tak panel Rozjezd po uložení IBAN dál hlásil „krok 9/10 · Profil firmy —
 * nemá vyplněné číslo účtu", ačkoli server už vracel 10/10. Hlídat to
 * v každé z desítek mutací zvlášť se prokazatelně nedaří, takže pravidlo
 * platí jednou, tady: **každý úspěšný zápis přes ``useMutation`` označí
 * readiness za zastaralou**. Aktivní dotaz (dok je na každé admin stránce)
 * se refetchne, neaktivní se jen označí — mimo admin to nestojí nic.
 *
 * Mutace, která readiness nemění (sonda, zkušební nacenění, čtení přes
 * POST) nebo si ji obnovuje sama, se vyřadí přes ``meta: { readiness: false }``.
 * Zápisy mimo ``useMutation`` (holé ``apiFetch``) volají
 * {@link markReadinessStale} samy.
 */

import type { QueryClient } from "@tanstack/react-query";

/** Týž klíč jako ``adminReadinessKey`` — tady bez importu dotazů, ať lib nezávisí na api. */
const READINESS_KEY = ["admin", "readiness"] as const;

export function markReadinessStale(client: QueryClient): Promise<void> {
  return client.invalidateQueries({ queryKey: READINESS_KEY });
}

/** Napojí pravidlo na klienta; vrací odhlášení (testy). */
export function refreshReadinessAfterWrites(client: QueryClient): () => void {
  return client.getMutationCache().subscribe((event) => {
    if (event.type !== "updated" || event.action.type !== "success") return;
    if (event.mutation.meta?.readiness === false) return;
    void markReadinessStale(client);
  });
}
